module.exports = __webpack_public_path__ + "img/nav_(4).76ef8ed9.png";